import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import {UserManagementService} from "../../data-access/user-management.service";
import {Subscription} from "rxjs";
import {AuthService} from "../../../login/data-access/auth.service";

@Component({
    selector: 'userManagementMenu',
    templateUrl: './userManagementMenu.html',
    styleUrls: ['userManagementMenu.css'],
    standalone: false
})
export class UserManagementMenuComponent implements OnInit, OnDestroy {
  constructor(
    private router: Router
  ) {}
  authService = inject(AuthService)
  showAllUsers = false
  userCreate = false
  roleManager = false
  ngOnInit() {
  }

  ngOnDestroy() {
    this.userPermissionSub.unsubscribe();
  }

  allUsersClick() {
    this.router.navigate(['dashboard/UserManagement/AllUsers'])
  }

  userRolesClick() {
    this.router.navigate(['dashboard/UserManagement/UserRoles'])
  }

  addNewUser() {
    this.router.navigate(['dashboard/UserManagement/AllUsers/AddNewUser'])
  }

  importUsers() {
    this.router.navigate(['dashboard/UserManagement/AllUsers/ImportUsers'])
  }

  userPermissionSub: Subscription = this.authService.userDashboard$.subscribe((user) => {
    if(user.result.some(el => el.ui === 'UserManage')) {
      this.showAllUsers = true
    }
    if(user.result.some(el => el.ui === 'UserCreate')) {
      this.userCreate = true
    }
    if(user.result.some(el => el.ui === 'UserRoleManage') || user.result.some(el => el.ui === 'RoleCreate')) {
      this.roleManager = true
    }
  })
}
